import React, { useEffect, useContext, useState } from "react";
import { styles } from "../patients/dashboardstyle";

import api, { API_URL, showAlert, AuthContext } from "../util/api";
import { Link, useNavigate } from "react-router-dom";

import Navbar from "../header";
import Footer from "../footer";
import "../paginationstyle.css"
import PremiumLoader from "../loading";
import NoData from "../components/nodata";
import DoctorTable from "./doctortable";

export default function DocCompletedAppoint() {

    const { User, token, Doctor } = useContext(AuthContext);
    const [loading , setLoader]  = useState(true);
    const router = useNavigate();


    const [appointments, setAppointment] = useState([]);

    const fadeIn = {
        animation: "fadeIn 0.8s ease-out",
    };
    const slideUp = {
        animation: "slideUp 0.8s ease-out",
    };

    const [hovered, setHovered] = React.useState(null);

    // PAGINATION STATE
    const [pagination, setPagination] = useState({
        current_page: 1,
        last_page: 1,
        next_page_url: null,
        prev_page_url: null,
    });

    // FETCH DATA
    const getdata = async (page = 1) => {
        setLoader(true);
        const response = await api.get(`${API_URL}/doctor-completed-appointments?page=${page}`);

        if (response.data.status === "success") {
            let info = response.data;

            setAppointment(info.appointments.data);

            setPagination({
                current_page: info.appointments.current_page,
                last_page: info.appointments.last_page,
                next_page_url: info.appointments.next_page_url,
                prev_page_url: info.appointments.prev_page_url,
            });

            setLoader(false);

        } else {
            showAlert("error", "Error!", response.data.message);
            setLoader(false);
        }
    };

    useEffect(() => {
        if (User == null || token == null) {
            router("/login");
        }
        if (Doctor == null) {
            router("/");
        }
        getdata();
    }, []);

    return (
        <>
            <Navbar menuColor="red" />

            <section style={{ marginTop: 100 }}>
                <div style={styles.container}>

                    <div
                        style={{
                            ...styles.card,
                            ...(hovered === "table" && styles.cardHover),
                            ...fadeIn,
                        }}
                        onMouseEnter={() => setHovered("table")}
                        onMouseLeave={() => setHovered(null)}
                    >

                        <div style={styles.header}>
                            <Link to="/doctor-dashboard">
                                <button
                                    onClick={() => router(-1)}
                                    style={{
                                        background: "transparent",
                                        border: "none",
                                        color: "#007bff",
                                        cursor: "pointer",
                                        fontSize: 16,
                                        padding: 0,
                                    }}
                                    aria-label="Go back"
                                >
                                    ← Back
                                </button>
                            </Link>
                        </div>

                        <br />
                        <div style={styles.header}>Completed Appointments</div>
                        <br />


                       {    loading  ? <>   
                       
                       <PremiumLoader />
                       </> : 

                       <>

                      

                        {    appointments.length  ===  0  ?   <>
                        
                        < NoData />
                        
                        </> : 
                        <> 


                        <DoctorTable styles={styles} appointments={appointments} slideUp={slideUp} />

                              



                        {/* PAGINATION UI */}
                        <div style={{ display: "flex", justifyContent: "center", marginTop: 25 }}>
                            <ul className="pagination">

                                {/* PREV */}
                                <li className={`page-item ${!pagination.prev_page_url ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() =>
                                            pagination.prev_page_url &&
                                            getdata(pagination.current_page - 1)
                                        }
                                    >
                                        ‹ Prev
                                    </button>
                                </li>

                                {/* PAGE NUMBERS */}
                                {[...Array(pagination.last_page)].map((_, i) => (
                                    <li
                                        key={i}
                                        className={`page-item ${pagination.current_page === i + 1 ? "active" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => getdata(i + 1)}
                                        >
                                            {i + 1}
                                        </button>
                                    </li>
                                ))}

                                {/* NEXT */}
                                <li className={`page-item ${!pagination.next_page_url ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() =>
                                            pagination.next_page_url &&
                                            getdata(pagination.current_page + 1)
                                        }
                                    >
                                        Next ›
                                    </button>
                                </li>

                            </ul>
                        </div>
                        </>

                                    }

                        </>

                          }

                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
}
